import { useState, useEffect } from 'react'

const useInfiniteScroll = (callback) => {
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  useEffect(() => {
    if (!loading || !callback) return
    setTimeout(() => {
      callback().finally(() => setLoading(false))
    }, 100)
  }, [loading])

  const handleScroll = () => {
    if (
      Math.round(window.innerHeight + document.documentElement.scrollTop) !==
        Math.round(document.documentElement.offsetHeight) ||
      loading
    ) {
      return
    }
    setLoading(true)
  }

  return [loading, setLoading]
}

export default useInfiniteScroll
